import { getSDGRepository } from "../Infrastructure/SDG.repository";

export async function getSDGLogic(params) {
  return getSDGRepository(params);
}
